import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Component to handle backward compatibility for old chat URLs
 * Redirects /?id=chatId to /chat/chatId
 */
const ChatRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const chatId = params.get('id') || params.get('chatId');
    
    if (chatId) {
      // Redirect to new URL format
      navigate(`/c/${chatId}`, { replace: true });
    }
  }, [location.search, navigate]);

  return null; // This component doesn't render anything
};

export default ChatRedirect;
